import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=7b0d494e"
import script from "./ProfileData.vue?vue&type=script&lang=js"
export * from "./ProfileData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports